import { jsx as R, Fragment as O } from "react/jsx-runtime";
import { useState as _, useEffect as g, createElement as W, useRef as G, useCallback as I, useMemo as K } from "react";
const l = {
  cache: {},
  module: {}
}, q = "route-resource-preload-manifest.json", b = typeof window > "u" ? {} : window;
function T(t) {
  return t && t.__esModule ? t.default : t;
}
function x(t, e) {
  return W(T(t), e);
}
function H(t) {
  var d;
  const { loader: e, loading: n, submodule: o, visible: r = !0, suspense: c } = t, k = t.type || "component";
  let h;
  const y = e.toString().match(/"([^"]*)"/), s = y ? y[1].toLocaleLowerCase() : "";
  function M() {
    let f = "pending", a = null, i = null;
    return (u) => {
      switch (f) {
        case "pending": {
          const F = Promise.resolve(u).then((L) => {
            f = "resolved", a = L;
          });
          throw f = "loading", i = F, i;
        }
        case "loading":
          throw i;
        case "resolved":
          return a;
      }
    };
  }
  const m = M(), P = () => e().then((a) => (h = a[o] || a.default, s && l.module[s] && (l.module[s].loaded = !0), h)).catch((a) => (s && l.module[s] && (l.module[s].loaded = !0), Promise.reject(a))), p = () => P(), E = () => m(P());
  return s && !["/", "./"].includes(s) && (l.module[s] = {
    preload: p,
    loaded: ((d = l.module[s]) == null ? void 0 : d.loaded) || !1
  }), Object.assign({
    component: (f) => {
      var L;
      const { onEnd: a, ...i } = f, [u, F] = _(!!(s && ((L = l.module[s]) != null && L.loaded) && h));
      return r ? (g(() => {
        u && a && a();
      }, [u]), c && !u ? x(E(), i) : (g(() => {
        var $;
        ($ = l.module[s]) != null && $.loaded && h && !u ? F(!0) : u || P().then(() => {
          F(!0);
        });
      }, []), u ? x(h, i) : n ? W(n, i) : /* @__PURE__ */ R(O, {}))) : /* @__PURE__ */ R(O, {});
    },
    util: P
  }[k], { preload: p });
}
const S = (t) => {
  const e = b.__routerResourcePreloadManifest && b.__routerResourcePreloadManifest[t];
  return e && e.length && e instanceof Array ? e : [];
}, A = async (t) => {
  if (b.__routerResourcePreloadManifest)
    return b.__routerResourcePreloadManifest;
  const { publicPath: e, filename: n } = t;
  let o = e.endsWith("/") ? e + n : `${e}/${n}`;
  return fetch(o).then((r) => r.json()).then((r) => (b.__routerResourcePreloadManifest = r, r));
}, D = async (t, e) => t ? b.__routerResourcePreloadManifest ? S(t) : A(e).then(() => S(t)) : [], j = (t, e) => {
  const n = Object.keys(l.module);
  if (e === "script")
    for (let o = 0; o < n.length; o++) {
      const r = n[o];
      if (t.match(r) || r.match(t)) {
        if (l.module[r].loaded)
          return !0;
        l.module[r].preload();
        break;
      }
    }
  else if (e === "mf")
    for (let o = 0; o < n.length; o++) {
      const r = n[o];
      if (r.match(t)) {
        if (l.module[r].loaded)
          return !0;
        l.module[r].preload();
        break;
      }
    }
}, N = (t) => {
  if (!t.length)
    return;
  const e = (n, o) => {
    if (l.cache[n])
      return;
    l.cache[n] = !0;
    const r = n.split("/");
    let c;
    switch (o) {
      case "script":
        j(n.toLocaleLowerCase(), "script") || (c = document.createElement("script"), c.src = n.startsWith("/") || n.startsWith("http") ? n : `/${n}`);
        break;
      case "mf":
        j(`${r[0].toLocaleLowerCase()}_${r[1].toLocaleLowerCase()}`, "mf") || r[0] && b[r[0]].get("./" + r[1]);
        break;
      default:
        c = document.createElement("link"), c.as = o, c.rel = "prefetch", c.href = `${n}`, c.crossOrigin = "crossorigin";
        break;
    }
    c && document.head.appendChild(c);
  };
  t.forEach((n) => {
    e(n.href, n.type);
  });
};
function J(t) {
  const { flag: e, children: n, publicPath: o = "", onClick: r, filename: c = q, action: k, className: h } = t, [v, y] = _(!1), [s, M] = _(!1), [m, P] = _(!1), [p, E] = _([]), w = G(null), C = I(() => {
    N(p), P(!0);
  }, [p]), d = I(() => {
    typeof requestIdleCallback > "u" ? setTimeout(() => {
      C();
    }, 0) : requestIdleCallback(C, { timeout: 1e3 });
  }, [C]), f = I(() => {
    m || d();
  }, [v, d, m]);
  g(() => {
    !v || m || d();
  }, [v, d, m]), g(() => {
    if (!s || m || !w.current || typeof IntersectionObserver > "u" || !p.length)
      return;
    let i = new IntersectionObserver((u) => {
      u.length && u[0].isIntersecting && d();
    });
    return i.observe(w.current), () => i.disconnect();
  }, [s, p, m, d]), g(() => {
    D(e, { publicPath: o, filename: c }).then((i) => {
      E(i);
    });
  }, [e, o, c]), g(() => {
    k === "init" ? y(!0) : k === "inview" && M(!0);
  }, [k]);
  const a = K(() => ({
    onMouseEnter: f,
    onClick: r,
    ref: w
  }), [f, r, w]);
  return /* @__PURE__ */ R("span", { ...a, className: h, children: n });
}
class Q {
  constructor(e) {
    this.publicPath = (e == null ? void 0 : e.publicPath) || "", this.filename = (e == null ? void 0 : e.filename) || q, this.option = {
      publicPath: this.publicPath,
      filename: this.filename
    }, A({
      publicPath: this.publicPath,
      filename: this.filename
    });
  }
  run(e) {
    D(e, this.option).then((n) => {
      N(n);
    });
  }
}
export {
  J as PreloadLink,
  Q as Preloader,
  H as dynamic
};
